var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-box"},[(_vm.loading)?_c('div',{staticClass:"loading-box"},[_c('i',{staticClass:"el-icon-loading"})]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }